import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import { FaUpload, FaFileExcel, FaDownload } from "react-icons/fa"
import sampleFile from "../../assets/customers.xlsx"

const ImportSheet = ({ open, toggle, onUpload }) => {
  const [file, setFile] = useState(null)
  const [fileName, setFileName] = useState("")
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleFileChange = e => {
    const selected = e.target.files[0]
    if (!selected) return

    const allowed = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "text/csv",
    ]
    const ext = selected.name.split(".").pop().toLowerCase()
    const validExt = ["xlsx", "xls", "csv"].includes(ext)

    if (!allowed.includes(selected.type) && !validExt) {
      setErrors({ file: "Only Excel (.xlsx, .xls) or CSV files are allowed" })
      return
    }
    if (selected.size > 1000 * 1024 * 1024) {
      setErrors({ file: "File size must be less than 1000 MB" })
      return
    }
    setFile(selected)
    setFileName(selected.name)
    setErrors({})
  }

  const validate = () => {
    if (!file) {
      setErrors({ file: "Please upload an Excel or CSV file" })
      return false
    }
    return true
  }

  const resetForm = () => {
    setFile(null)
    setFileName("")
    setErrors({})
  }

  const handleSubmit = async () => {
    if (!validate()) return
    setLoading(true)
    await onUpload({ file })
    setLoading(false)
    resetForm()
    toggle()
  }

  const handleClose = () => {
    resetForm()
    toggle()
  }

  return (
    <Modal isOpen={open} centered size="md" toggle={handleClose}>
      <ModalHeader toggle={handleClose}>
        Import Customers from Sheet
      </ModalHeader>

      <ModalBody>
        <Form>
          <FormGroup>
            <div className="d-flex align-items-center justify-content-between mb-1">
              <Label className="mb-0">
                Upload Excel / CSV <span className="text-danger">*</span>
              </Label>
              <a
                href={sampleFile}
                download="customers.xlsx"
                className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                style={{ fontSize: 12 }}
              >
                <FaDownload size={11} />
                Download Sample File
              </a>
            </div>
            <label
              style={{
                display: "block",
                border: `2px dashed ${
                  errors.file ? "#dc3545" : "rgba(85,110,230,0.3)"
                }`,
                borderRadius: 10,
                padding: "28px 20px",
                textAlign: "center",
                cursor: "pointer",
                background: fileName ? "rgba(85,110,230,0.04)" : "transparent",
                transition: "all 0.2s",
              }}
            >
              <input
                type="file"
                accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              {fileName ? (
                <div>
                  <FaFileExcel size={32} color="#1D6F42" />
                  <p
                    className="mb-0 mt-2"
                    style={{ fontSize: 13, fontWeight: 600, color: "#333" }}
                  >
                    {fileName}
                  </p>
                  <p
                    className="mb-0 mt-1"
                    style={{ fontSize: 11, color: "#999" }}
                  >
                    Click to change file
                  </p>
                </div>
              ) : (
                <div>
                  <FaUpload size={28} color="#556ee6" />
                  <p
                    className="mb-0 mt-2"
                    style={{ fontSize: 13, color: "#666" }}
                  >
                    Click to upload Excel or CSV
                  </p>
                  <p
                    className="mb-0 mt-1"
                    style={{ fontSize: 11, color: "#999" }}
                  >
                    Supported: .xlsx, .xls, .csv &nbsp;|&nbsp; Max size: 10 MB
                  </p>
                </div>
              )}
            </label>
            {errors.file && (
              <div className="invalid-feedback d-block">{errors.file}</div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button className="btn-blue" onClick={handleSubmit} disabled={loading}>
          <FaUpload className="me-2" />
          {loading ? "Uploading..." : "Import"}
        </Button>
        <Button color="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ImportSheet
